import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { handleOAuthCallback, loadTokens, redirectToLogin } from "../auth";

export function CallbackPage() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      const err = await handleOAuthCallback();
      if (err === "Accesso in corso…") return;
      if (err) {
        setError(err);
        return;
      }
      if (!loadTokens()) {
        redirectToLogin();
        return;
      }
      window.location.replace("/");
    })();
  }, []);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-surface p-6 text-center">
        <h2 className="text-lg font-semibold text-slate-900">Errore accesso</h2>
        <p className="text-sm text-red-600">{error}</p>
        <Link to="/" className="text-sm font-medium text-ocean-600 hover:text-ocean-700">
          Torna al launcher
        </Link>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface" role="status">
      <p className="text-sm text-slate-500">Accesso in corso…</p>
    </div>
  );
}
